<template>
  <div class="footer-wrap">
    <div class="pc">
      <div class="footer-inner">
        <div class="footer-menu">
          <RouterLink to="/about">잠자는 국회 & 입법평론</RouterLink>
          <span class="footer-bar"></span>
          <RouterLink to="/nth-national-assembly"
            >22대국회 법안처리 현황판</RouterLink
          >
          <span class="footer-bar"></span>
          <RouterLink to="/nth-national-assembly?type=congressman"
            >22대 국회의원 입법현황판</RouterLink
          >
          <span class="footer-bar"></span>
          <RouterLink to="/congressman-bill"
            >국회의원 1호 법안 상황판</RouterLink
          >
          <span class="footer-bar"></span>
          <RouterLink to="/standing-committee-bill"
            >상임위원회 법안처리 현황</RouterLink
          >
        </div>
        <div class="divider"></div>
        <div class="footer-with-logo">
          <div>
            <div class="footer-menu">
              <span>레몬 컴퍼니(Legislative Monitoring Company)</span>
              <span class="footer-bar"></span>
              <span>이메일 : sleeping.assembly@gmail.com</span>
              <!-- <span class="footer-bar"></span> -->
              <!-- <span>대표 : 고병국</span> -->
              <!-- <span class="footer-bar"></span> -->
              <!-- <span>사업자등록번호 : 858-43-01050</span> -->
              <!-- <span class="footer-bar"></span> -->
              <!-- <span>주소 : 서울 종로구 자하문로 36길 16-14, 10동 1021호</span> -->
            </div>
            <!-- <div class="footer-menu margin-top-11">
              <span>이메일 : sleeping.assembly@gmail.com</span>
              <span class="footer-bar"></span>
              <span>계좌번호 : 신한은행 110-564-296344 (레몬컴퍼니)</span>
            </div> -->
            <div class="footer-description">
              잠자는국회는 국회 혁신을 위해 무료로 제공되는 서비스입니다.
            </div>
          </div>
          <div class="footer-logo">
            <img
              width="200"
              :src="require('../../assets/img/lemon-logo.png')"
              alt="레몬컴퍼니 로고"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="footer-logo m">
        <img
          width="200"
          :src="require('../../assets/img/lemon-logo.png')"
          alt="레몬컴퍼니 로고"
        />
      </div>
      <ul class="footer-content-m">
        <li>레몬 컴퍼니(Legislative Monitoring Company)</li>
        <!-- <li>대표 : 고병국</li> -->
        <!-- <li>사업자등록번호 : 858-43-01050</li> -->
        <!-- <li>주소 : 서울 종로구 자하문로 36길 16-14, 10동 1021호</li> -->
        <li>이메일 : sleeping.assembly@gmail.com</li>
        <!-- <li>계좌번호 : 신한은행 110-564-296344 (레몬컴퍼니)</li> -->
      </ul>
      <div class="footer-sub-m">
        잠자는국회는 국회 혁신을 위해 무료로 제공되는 서비스입니다.
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "LayoutFooter",
  components: { RouterLink },
};
</script>

<style scoped>
.footer-wrap {
  background-color: #2f2f2f;
  padding: 5vw 0;
  display: flex;
  justify-content: center;

  & .mobile {
    display: none;
  }

  @media only screen and (max-width: 1040px) {
    & .pc {
      display: none;
    }

    & {
      padding: 3vw 0;
    }
    & .mobile {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}

.footer-inner {
  color: #adadad;
  font-family: GmarketSansMedium;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.45px;
  max-width: 1320px;
  width: 100%;

  @media only screen and (max-width: 1360px) {
    max-width: 1200px;
  }

  @media only screen and (max-width: 1200px) {
    font-size: 15px;
  }
}

.footer-description {
  color: #adadad;
  font-family: GmarketSansMedium;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.45px;
  margin-top: 40px;

  @media only screen and (max-width: 1200px) {
    font-size: 15px;
  }
}

.footer-menu {
  display: flex;
  gap: 19px;
  align-items: center;

  & a {
    color: #adadad;
  }
}

.footer-menu.margin-top-11 {
  margin-top: 11px;
}

.footer-bar {
  width: 1px;
  display: inline-block;
  height: 14px;
  background-color: #adadad;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #adadad;
  margin: 40px 0;
}

.footer-with-logo {
  display: flex;
  gap: 32px;
  align-items: flex-end;
  font-size: 15px;
  justify-content: space-between;

  @media only screen and (max-width: 1170px) {
    font-size: 12px;
  }
}

.footer-logo {
  width: 200px;
  height: 57px;

  &.m img {
    width: 200px;
  }

  @media only screen and (max-width: 1040px) {
    width: 100%;
    text-align: center;
    height: auto;
    padding-bottom: 3vw;
    border-bottom: 1px solid #adadad;
  }
}

.footer-content-m {
  margin: 3vw 0;
  display: flex;
  flex-direction: column;
  gap: 0.9vw;

  & li {
    font-family: GmarketSansMedium;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.45px;
    text-align: center;
    color: #adadad;
  }

  @media only screen and (max-width: 1040px) {
    margin: 30px 0;

    & li {
      font-size: 14px;
    }
  }
}

.footer-sub-m {
  font-family: GmarketSansMedium;
  text-align: center;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #adadad;
  margin: 0 30px;

  @media only screen and (max-width: 1040px) {
    font-size: 14px;
  }
}
</style>
